module.exports = __webpack_public_path__ + "static/media/dateFilters.d833d6b4.svg";